import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

// Ленивая загрузка страниц
const BookingPage = lazy(() => import('./pages/BookingPage'));
const OrdersPage = lazy(() => import('./pages/OrdersPage'));
const DocumentsPage = lazy(() => import('./pages/DocumentsPage'));
const SingleSquadPage = lazy(() => import('./pages/SingleSquadPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const AuthPage = lazy(() => import('./pages/AuthPage'));

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Публичный маршрут - авторизация */}
          <Route path="/auth" element={<AuthPage />} />
        
          {/* Защищенные маршруты */}
          <Route path="/*" element={
            <Layout>
              <Suspense fallback={<div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '200px',
                fontSize: '18px',
                color: '#07640a'
              }}>Загрузка...</div>}>
                <Routes>
                  <Route path="/" element={
                    <ProtectedRoute>
                      <BookingPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/booking" element={
                    <ProtectedRoute>
                      <BookingPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/orders" element={
                    <ProtectedRoute>
                      <OrdersPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/documents" element={
                    <ProtectedRoute>
                      <DocumentsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/single-squad" element={
                    <ProtectedRoute>
                      <SingleSquadPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile" element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  } />
                
                  {/* Редирект на booking если корневой маршрут защищенный */}
                  <Route path="*" element={<Navigate to="/booking" replace />} />
                </Routes>
              </Suspense>
            </Layout>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;